import React from 'react';
import { Eyebrow } from './Eyebrow';
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  tone?: 'light' | 'dark';
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  tone = 'light'
}: SectionHeadingProps) {
  const titleColor = tone === 'dark' ? 'text-ivory' : 'text-forest';
  const subColor = tone === 'dark' ? 'text-ivory/85' : 'text-forest/75';
  return <div className="text-center max-w-3xl mx-auto mb-8 md:mb-12" data-id="element-210" data-mp="bleubsm9cj35">
      {eyebrow && <div className="mb-3 md:mb-4" data-id="element-211" data-mp="gjq463cjytld">
          <Eyebrow tone={tone} data-id="element-212" data-mp="glj99e7ip5r9">{eyebrow}</Eyebrow>
        </div>}
      <h2 className={`font-serif text-[1.6rem] md:text-4xl lg:text-5xl font-bold leading-[1.12] md:leading-tight ${titleColor}`} data-id="element-213" data-mp="1tsj3w9x6k0e">
        {title}
      </h2>
      {subtitle && <p className={`mt-3 md:mt-4 font-sans text-[15px] md:text-lg leading-[1.5] max-w-2xl mx-auto ${subColor}`} data-id="element-214" data-mp="ui6gqax3jebf">
          {subtitle}
        </p>}
    </div>;
}